import {
  Component, Input,
} from '@angular/core';
import { ModalService, RestApiService } from '../../service';
import { P } from '../../ui-kit';

@Component({
  selector: 'lib-user-files',
  templateUrl: './user-files.component.html',
  styleUrls: ['./user-files.component.scss'],
})
export class UserFilesComponent {
  @Input() files: P.ApplicationFile[] = [];

  constructor(
    private modal: ModalService,
    private restApi: RestApiService,
  ) {

  }

  working = false;

  viewFile(file: P.ApplicationFile) {
    this.working = true;

    this.restApi
      .getFile(file.key)
      .toPromise()
      .then((blob) => window.open(URL.createObjectURL(blob)))
      .catch((error) => this.modal.open(error?.message || 'Oops', { id: 'error-modal' }))
      .finally(() => this.working = false);
  }
}
